export const SuperRole = [
    {
        name: 'Super Admin',
        abbr: 'super_admin'
    },
    {
        name: 'Admin',
        abbr: 'admin'
    },
    {
        name: 'Support Staff',
        abbr: 'support_staff'
    },
];

export const AdminRole = [
    {
        name: 'Admin',
        abbr: 'admin'
    },
    {
        name: 'Super Senior',
        abbr: 'super_senior'
    },
    {
        name: 'Senior Master',
        abbr: 'senior_master'
    },
    {
        name: 'Master Agent',
        abbr: 'master_agent'
    },
    {
        name: 'Agent',
        abbr: 'agent'
    },
    {
        name: 'Affiliate',
        abbr: 'affiliate'
    },
    {
        name: 'Organization',
        abbr: 'organization'
    }

];

export const AdminType = { 
    Super: 'super',
    Tenant: 'tenant',
    Subscriber: 'subscriber',
    Organization: 'organization',
    Affiliate: 'affiliate'
}
